import { getProperty } from '../../functions/get-property';

export class HydraView {
  id: string;
  type: string;

  hydraFirst: string;
  hydraLast: string;
  hydraNext: string;

  constructor(response: {[index: string]: any}) {
    this.id = getProperty(response, '@id');
    this.type = getProperty(response, '@type');

    this.hydraFirst = getProperty(response, 'hydra:first');
    this.hydraLast = getProperty(response, 'hydra:last');
    this.hydraNext = getProperty(response, 'hydra:next');
  }
}
